export default __webpack_public_path__ + "static/media/hospital_menu_item.477d950e.svg";